import React, { Component } from "react";
import getConfig from "next/config";
import Link from "next/link";
import Feedback from "@containers/Support/Feedback";
import ArrowDown from "@components/Icons/ArrowDown";
import HtmlEmbed from "@components/ContentEditorView/HtmlEmbed";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

class TopFaqCard extends Component {
  state = {
    isActive: false,
  };

  toggleDisplay = () => {
    this.setState((prevState) => ({ isActive: !prevState.isActive }));
  };

  render() {
    const { isActive } = this.state;
    const { item } = this.props;

    if (!item) {
      return null;
    }

    return (
      <article
        className={`
        mt-2 w-full border rounded-tr-lg rounded-bl-lg overflow-hidden border-gray-1100
      `}
      >
        <div
          className="flex py-10px px-5 cursor-pointer"
          onClick={this.toggleDisplay}
        >
          <div className="pr-4 grow">
            {item.categories && item.categories.length > 0 && (
              <span
                className="text-newGray-mildDark text-sm font-medium leading-18.2 -tracking-0.29"
                style={{ marginBottom: "6px" }}
              >
                {item.categories[0].name}
              </span>
            )}

            <p>{item.title}</p>
          </div>

          <div
            className={`self-center duration-100 ${
              isActive ? "rotate-180" : ""
            }`}
          >
            <ArrowDown />
          </div>
        </div>

        <div hidden={!isActive}>
          <div className="py-3 px-4 lg:px-10 border-t border-gray-1100">
            <HtmlEmbed
              className="text-sm leading-20 -tracking-0.29"
              html={item.content}
            />

            {item.tags && (
              <div className="pt-4">
                <div className="flex flex-wrap -ml-2">
                  {item.tags.map((item) => (
                    <Link
                      key={item.slug}
                      href={`${
                        settings.baseUrl
                      }/suport-clienti/cauta/?ts=${encodeURIComponent(
                        item.title
                      )}`}
                      passHref
                    >
                      <a className="ml-2 mb-2 px-2 py-1 rounded-tr-lg rounded-bl-lg text-13px leading-none -tracking-0.18 bg-newsletterYellow-light hover:bg-newsletterYellow-hover">
                        {item.title}
                      </a>
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className="border-t border-gray-1100">
            <Feedback articleSlug={item.slug} />
          </div>
        </div>
      </article>
    );
  }
}

export default TopFaqCard;
